"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SEGMENT = exports.DIRECTION = exports.CARD_THEME = exports.BGC_COLOR = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSlick = _interopRequireDefault(require("react-slick"));
var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));
var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.text-info"));
var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.image"));
var _gerenciatdUnifiedcomponents3 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.button"));
var _gerenciatdUtils = require("@bit/gerenciatd.utils.common");
var _gerenciatdUnifiedcomponents4 = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.arrow"));
require("./slick/slick.scss");
require("./slick/slick-theme.scss");
require("./ProductList.scss");
var _productListUtils = require("./productListUtils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
const SEGMENT = {
  GP: 'gp',
  EMP: 'emp'
};
exports.SEGMENT = SEGMENT;
const BGC_COLOR = {
  GREY1: 'grey1',
  EMPGREY1: 'emp-grey1',
  BLACK: 'black',
  WHITE: 'white'
};
exports.BGC_COLOR = BGC_COLOR;
const CARD_THEME = {
  SHORT: 'short',
  LARGE: 'large'
};
exports.CARD_THEME = CARD_THEME;
const DIRECTION = {
  COLUMN: 'column',
  ROW: 'row'
};
exports.DIRECTION = DIRECTION;
class ProductList extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      try {
        const {
          id
        } = this.state;
        const {
          featuredCards
        } = this.props;
        // Marcamos con doble ancho si aplica
        if (!this.productList) {
          return null;
        } else if (featuredCards && this.productList.length === 1) {
          (0, _productListUtils.generateOneBigSlickSlides)(id);
        } else if (featuredCards && this.productList.length === 2) {
          (0, _productListUtils.generateTwoBigSlickSlides)(id);
        } else if (featuredCards && this.productList.length === 3) {
          (0, _productListUtils.generateThreeBigSlickSlides)(id);
        }
      } catch (err) {
        console.log(err);
      }
    });
    _defineProperty(this, "getReadyComponentList", components => {
      const productListItems = [];
      const itemKeyList = components ? Object.keys(components) : [];
      itemKeyList.forEach(key => {
        if (key.indexOf('ProductItemCard') > -1) {
          const currentProductItemData = components[key];
          currentProductItemData.name = `${key}`;
          productListItems.push(currentProductItemData);
        }
      });
      return productListItems;
    });
    _defineProperty(this, "beforeChange", (oldIndex, newIndex) => {
      if (oldIndex !== newIndex) {
        const {
          slidesToShow
        } = this.state;
        const page = Math.ceil(newIndex / slidesToShow);
        this.setState({
          page
        });
      }
    });
    _defineProperty(this, "slideToPrev", () => {
      this.slider.slickPrev();
    });
    _defineProperty(this, "slideGoTo", page => {
      this.slider.slickGoTo(page);
    });
    _defineProperty(this, "slideToNext", () => {
      this.slider.slickNext();
    });
    _defineProperty(this, "togleArrows", () => {
      const {
        arrowsHidden
      } = this.state;
      this.setState({
        arrowsHidden: !arrowsHidden
      });
    });
    const {
      components: _components,
      bgImage,
      maxSlidesToShow,
      direction,
      slides
    } = props;
    const _id = (0, _gerenciatdUtils.generateComponentId)('ProductHorizontalScrollList', '');
    (0, _productListUtils.generateBgProductList)(_id, bgImage);
    this.productList = _components ? this.getReadyComponentList(_components) : null;
    const _slidesToShow = direction !== DIRECTION.ROW && maxSlidesToShow > slides && this.productList.length >= maxSlidesToShow ? maxSlidesToShow : slides;
    this.state = {
      id: _id,
      page: 0,
      arrowsHidden: false,
      slidesToShow: _slidesToShow,
      pageNumber: Math.ceil(this.productList.length / _slidesToShow)
    };
  }
  render() {
    const {
      id,
      page,
      arrowsHidden,
      pageNumber,
      slidesToShow
    } = this.state;
    const {
      components,
      taggingInfo,
      bgColor,
      cardTheme,
      toSeeNext,
      arrowSize,
      arrowOpacity,
      segment,
      bgColorArrow,
      colorArrow,
      ItemComponent,
      direction,
      isSlider
    } = this.props;
    const COMPONENT_NAME = taggingInfo.componentName ? taggingInfo.componentName : 'ProductList';
    const mainTaggingInfo = _objectSpread(_objectSpread({}, taggingInfo), {}, {
      componentName: COMPONENT_NAME
    });
    const bgColorCss = ` ProductHorizontalScrollList_bgColor--${bgColor}-${segment}`;
    const segmentCss = `ProductHorizontalScrollList--${segment}`;
    const componentClass = `ProductHorizontalScrollList ${segmentCss} ${bgColorCss}`;
    let layoutClass = direction ? `layout layout-${direction}` : '';
    const leftArrowVisible = !arrowsHidden && page > 0;
    let rightArrowVisible = !arrowsHidden && pageNumber > 1 && page + 1 < pageNumber;
    const cndInfoGap = components && (components['TextInfo-1'] || components['TextInfo-2'] || components['TextInfo-3'] || components['Image-1']);
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
      id: id,
      className: componentClass,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: layoutClass,
          children: [cndInfoGap && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "infoGap",
            children: [components['TextInfo-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, components['TextInfo-1']), {}, {
              segment: segment,
              className: "title"
            })), components['TextInfo-2'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, components['TextInfo-2']), {}, {
              segment: segment,
              className: "description1"
            })), components['TextInfo-3'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, components['TextInfo-3']), {}, {
              segment: segment,
              className: "description2"
            })), components['Image-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, components['Image-1']), {}, {
              className: "titleImage"
            }))]
          }), !isSlider && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "productsGap",
            children: this.productList && this.productList.map(item => {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(ItemComponent, {
                bgColor: item.bgColor,
                features: item.features,
                featureStyles: item.featureStyles,
                img: item.img,
                brandImg: item.brandImg,
                components: item.components,
                onEnterAndLeave: this.togleArrows,
                border: item.border,
                boxShadow: item.boxShadow,
                onMouseEnter: item.onMouseEnter,
                segment: segment,
                productInfoHeight: item.productInfoHeight,
                taggingInfo: mainTaggingInfo,
                cardTheme: cardTheme,
                pictureGapHeight: cardTheme,
                layout: item.layout,
                width: item.width
              }, item.name);
            })
          }), isSlider && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: `scrollSliderGap ${!cndInfoGap ? 'scrollSliderGap--full' : ''}`,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactSlick.default, _objectSpread(_objectSpread({
              ref: slider => {
                this.slider = slider;
              }
            }, (0, _productListUtils.SETTINGS)({
              toSeeNext,
              slidesToShow,
              beforeChange: this.beforeChange
            })), {}, {
              children: this.productList && this.productList.map(item => {
                return /*#__PURE__*/(0, _jsxRuntime.jsx)(ItemComponent, {
                  bgColor: item.bgColor,
                  features: item.features,
                  featureStyles: item.featureStyles,
                  img: item.img,
                  brandImg: item.brandImg,
                  components: item.components,
                  onEnterAndLeave: this.togleArrows,
                  border: item.border,
                  boxShadow: item.boxShadow,
                  onMouseEnter: item.onMouseEnter,
                  segment: segment,
                  productInfoHeight: item.productInfoHeight,
                  taggingInfo: mainTaggingInfo,
                  cardTheme: cardTheme,
                  pictureGapHeight: cardTheme,
                  layout: item.layout,
                  width: item.width
                }, item.name);
              })
            })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents4.default, {
              kind: _gerenciatdUnifiedcomponents4.ICONS_DIRECTION.LEFT,
              onClick: leftArrowVisible ? this.slideToPrev : null,
              visible: leftArrowVisible,
              taggingInfo: mainTaggingInfo,
              page2go: page,
              iconProps: {
                color: colorArrow,
                size: 16
              },
              size: arrowSize,
              opacity: arrowOpacity,
              bgColor: bgColorArrow
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents4.default, {
              kind: _gerenciatdUnifiedcomponents4.ICONS_DIRECTION.RIGHT,
              onClick: rightArrowVisible ? this.slideToNext : null,
              visible: rightArrowVisible,
              taggingInfo: mainTaggingInfo,
              page2go: page,
              iconProps: {
                color: colorArrow,
                size: 16
              },
              size: arrowSize,
              opacity: arrowOpacity,
              bgColor: bgColorArrow
            })]
          }), components.button && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "container--button",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, _objectSpread(_objectSpread({}, components.button), {}, {
              taggingInfo: mainTaggingInfo
            }))
          })]
        })
      })
    });
  }
}

// eslint-disable-next-line react/display-name
ProductList.WaitingComponent = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "configFake ProductHorizontalScrollList",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLoadingSkeleton.default, {
      count: 1,
      height: 30,
      width: "50%"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLoadingSkeleton.default, {
        count: 1,
        height: 180,
        width: "100%"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLoadingSkeleton.default, {
        count: 1,
        height: 180,
        width: 200
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLoadingSkeleton.default, {
        count: 1,
        height: 180,
        width: 200
      })]
    })]
  });
};
ProductList.propTypes = {
  /**
   * {
   *  "info": "Define los componentes para pintar una lista de componentes ProductItem",
   *  "kind": "both",
   *  "beautifulName": "components"
   * }
   */
  components: _propTypes.default.object,
  /**
   * {
   *  "info": "Permite contribuir la infomación que será enviada a analítica tras la interacción (objeto para el taggeado)",
   *  "kind": "both",
   *  "beautifulName": "Propiedades tagueo"
   * }
   */
  taggingInfo: _propTypes.default.object.isRequired,
  /**
   * {
   *  "info": "Define el color de fondo, uno de los colores del array BGC_COLOR, por defecto es grey1",
   *  "kind": "both",
   *  "beautifulName": "bgColor"
   * }
   */
  bgColor: _propTypes.default.oneOf([BGC_COLOR.GREY1, BGC_COLOR.EMPGREY1, BGC_COLOR.BLACK, BGC_COLOR.WHITE]),
  /**
   * {
   *  "info": "Define el color de fondo de la flecha",
   *  "kind": "both",
   *  "beautifulName": "bgColorArrow"
   * }
   */
  bgColorArrow: _propTypes.default.string,
  /**
   * {
   *  "info": "Define el color de la flecha",
   *  "kind": "both",
   *  "beautifulName": "colorArrow"
   * }
   */
  colorArrow: _propTypes.default.string,
  /**
   * {
   *  "info": "Define número de slides a mostrar en tamaño laptop, por defecto son 3",
   *  "kind": "both",
   *  "beautifulName": "slides"
   * }
   */
  slides: _propTypes.default.number,
  /**
   * {
   *  "info": "Aplica un estilo al slider para que muestre las tarjetas cortadas a la derecha, para seguir el principio de continidad. Está por defecto a true",
   *  "kind": "both",
   *  "beautifulName": "toSeeNext"
   * }
   */
  toSeeNext: _propTypes.default.bool,
  /**
   * {
   *  "info": "Indica el tamaño del botón para pasar las slides",
   *  "kind": "both",
   *  "beautifulName": "arrowSize"
   * }
   */
  arrowSize: _propTypes.default.string,
  /**
   * {
   *  "info": "Indica la opacidad del botón para pasar las slides",
   *  "kind": "both",
   *  "beautifulName": "arrowOpacity"
   * }
   */
  arrowOpacity: _propTypes.default.string,
  /**
   * {
   *  "info": "Indica el segmento: gp o emp",
   *  "kind": "both",
   *  "beautifulName": "segment"
   * }
   */
  segment: _propTypes.default.oneOf([SEGMENT.GP, SEGMENT.EMP]),
  /**
   * {
   *  "info": "Define el tema de la card, el tema actual CARD_THEME, por defecto es short",
   *  "kind": "both",
   *  "beautifulName": "cardTheme"
   * }
   */
  cardTheme: _propTypes.default.oneOf([CARD_THEME.SHORT, CARD_THEME.LARGE]),
  /**
   * {
   *  "info": "Define la colocacion de los elementos del componente",
   *  "kind": "both",
   *  "beautifulName": "direction"
   * }
   */
  direction: _propTypes.default.string,
  /**
   * {
   *  "info": "Define si se pintan cards con tamaño doble para destacarlas",
   *  "kind": "both",
   *  "beautifulName": "featuredCards"
   * }
   */
  featuredCards: _propTypes.default.bool,
  /**
   * {
   *  "info": "Define si se pintan cards en carrusel",
   *  "kind": "both",
   *  "beautifulName": "isSlider"
   * }
   */
  isSlider: _propTypes.default.bool,
  /**
   * {
   *  "info": "Define el numero maximo de cards a mostrar solo cuando el layout es Row",
   *  "kind": "both",
   *  "beautifulName": "maxSlidesToShow"
   * }
   */
  maxSlidesToShow: _propTypes.default.number
};
ProductList.defaultProps = {
  bgColor: BGC_COLOR.GREY1,
  slides: 3,
  toSeeNext: true,
  arrowSize: 'big',
  arrowOpacity: 'op-1',
  bgColorArrow: 'white',
  colorArrow: 'black',
  cardTheme: CARD_THEME.SHORT,
  direction: DIRECTION.ROW,
  featuredCards: false,
  segment: SEGMENT.GP,
  maxSlidesToShow: 3,
  isSlider: false
};
var _default = ProductList;
exports.default = _default;

//# sourceMappingURL=index.js.map